/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { InjectionToken, NgModule } from "@angular/core";

export const WindowToken = new InjectionToken<Window>("Window");
export function windowProvider() {
   return window;
}

@NgModule({
   declarations: [],
   providers: [{ provide: WindowToken, useFactory: windowProvider }]
})
export class WindowModule {}
